export default __webpack_public_path__ + "static/media/step2-a.47bbd307.png";